import camelize from 'camelize';
import normalizeAddressData from './normalize-address';

export default function addressParse(value) {
  const parsed = typeof value === 'string' ? JSON.parse(value) : value;
  const camelized = camelize(parsed);
  return normalizeAddressData(camelized);
}
